import React from 'react';
import { withRouter } from 'react-router-dom';
import CONSTANT from '../../constant';
import Loader from '../../component/common/Loader';
import { getSelectedOrActiveCycle, getEmployeeOtherDetails, saveEmployeeOtherDetails, updateEmployeeOtherDetails } from '../../actions/AppraisalCycleAction';

class OtherDetails extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showLoader: false,
            employeeCode: '',
            appraisalCycleId: null,
            isExisting: false,
            awardsHonours: '',
            parNotWrittenCount: '',
            propertyReturnDate: '',
            lastMedicalExamDate: '',
        };
    }

  componentDidMount() {
        window.scrollTo(0, 0);
        const employeeCode = this.props.match.params.code || '';
        document.title = 'Other Details - ' + CONSTANT.organisation.name;
        this.setState({ employeeCode }, () => {
            this.loadActiveCycleAndData();
        });
    }

    loadActiveCycleAndData = () => {
        this.setState({ showLoader: true });
        getSelectedOrActiveCycle().then((res: any) => {
            const cycle = res?.result;
            if (!cycle || !cycle.id) {
                alert('No appraisal cycle selected. Please select a cycle in the top bar.');
                this.setState({ showLoader: false });
                return;
            }
            this.setState({ appraisalCycleId: cycle.id }, () => {
                this.loadOtherDetails();
            });
        }).catch(() => {
            this.setState({ showLoader: false });
        });
    };

    loadOtherDetails = () => {
        const { employeeCode, appraisalCycleId } = this.state;
        getEmployeeOtherDetails({ employeeCode, appraisalCycleId }).then((res: any) => {
            const data = res?.result;
            if (data && data.id) {
                this.setState({
                    isExisting: true,
                    awardsHonours: data.awards_honours || data.awardsHonours || '',
                    parNotWrittenCount: data.par_not_written_count || data.parNotWrittenCount || '',
                    propertyReturnDate: this.formatDate(data.property_return_date || data.propertyReturnDate),
                    lastMedicalExamDate: this.formatDate(data.last_medical_exam_date || data.lastMedicalExamDate),
                });
            }
            this.setState({ showLoader: false });
        }).catch(() => {
            this.setState({ showLoader: false });
        });
    };

    formatDate = (dateStr: string) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return '';
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    onTextChange = (e: any) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    onSubmit = (e: any) => {
        e.preventDefault();
        const { employeeCode, appraisalCycleId, isExisting, awardsHonours, parNotWrittenCount, propertyReturnDate, lastMedicalExamDate } = this.state;

        if (!appraisalCycleId) {
            alert('No active appraisal cycle found');
            return;
        }

        this.setState({ showLoader: true });

        const payload = {
            employeeCode,
            appraisalCycleId,
            awardsHonours: awardsHonours || null,
            parNotWrittenCount: parNotWrittenCount || null,
            propertyReturnDate: propertyReturnDate || null,
            lastMedicalExamDate: lastMedicalExamDate || null,
        };

        const apiCall = isExisting
            ? updateEmployeeOtherDetails(payload)
            : saveEmployeeOtherDetails(payload);

        apiCall.then((res: any) => {
            this.setState({ showLoader: false });
            if (res?.status === 'failed') {
                alert(res.error || 'Failed to save other details');
            } else {
                this.setState({ isExisting: true });
                alert(isExisting ? 'Other details updated successfully!' : 'Other details saved successfully!');
            }
        }).catch(() => {
            this.setState({ showLoader: false });
        });
    };

    render() {
        const {
            showLoader, employeeCode,
            awardsHonours, parNotWrittenCount,
            propertyReturnDate, lastMedicalExamDate,
        } = this.state;

        return (
            <div className="container-fluid mb-3">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card homedob">
                            <div className="row">
                                <div className="col-md-8">
                                    <h1 className="page-title">
                                        <i className="fa fa-file-text-o text-secondary mr-2" />
                                        Other Details
                                    </h1>
                                    <p className="text-muted mb-0">Employee Code: <strong>{employeeCode}</strong></p>
                                </div>
                                <div className="col-md-4 text-right">
                                    <button
                                        className="btn btn-sm cancel-button"
                                        onClick={() => this.props.history.goBack()}
                                    >
                                        <i className="fa fa-arrow-left mr-2" />
                                        Back
                                    </button>
                                </div>
                            </div>

                            {showLoader && <Loader />}

                            <form onSubmit={this.onSubmit}>
                                {/* 10. Awards / Honours */}
                                <div className="row mt-3">
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label fw-semibold">
                                            10. Awards / Honours received during the year
                                        </label>
                                        <textarea
                                            name="awardsHonours"
                                            rows={4}
                                            className="form-control"
                                            value={awardsHonours}
                                            onChange={this.onTextChange}
                                            placeholder="Enter details of awards / honours received during the year"
                                        />
                                    </div>
                                </div>

                                {/* 11. PAR not written */}
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label fw-semibold">
                                            11. Number of officers for whom PAR was not written by the officer reported upon as Reporting/Reviewing Authority for the previous year
                                        </label>
                                        <textarea
                                            name="parNotWrittenCount"
                                            rows={4}
                                            className="form-control"
                                            value={parNotWrittenCount}
                                            onChange={this.onTextChange}
                                            placeholder="Enter details"
                                        />
                                    </div>
                                </div>

                                {/* 12. Property return date */}
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label fw-semibold">
                                            12. Date of filing the property return in the prescribed format for the year ending 31st December
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="propertyReturnDate"
                                            value={propertyReturnDate}
                                            onChange={this.onTextChange}
                                        />
                                    </div>
                                </div>

                                {/* 13. Medical examination date */}
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label fw-semibold">
                                            13. Date of last prescribed medical examination (for officers over 40 years of age)
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="lastMedicalExamDate"
                                            value={lastMedicalExamDate}
                                            onChange={this.onTextChange}
                                        />
                                        <small className="text-muted">
                                            Please attach a copy of the summary of the medical report. (Suggested summary format of the medical examination report is at Appendix I)
                                        </small>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end gap-2 mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={() => this.props.history.goBack()}
                                    >
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        Save
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(OtherDetails);
